<h2 mat-dialog-title>
  {{dialog.title}}
</h2>
<div mat-dialog-content
  class="content">
  <div [innerHTML]="dialog.content"></div>
  <inspekt-dynamic-form [fields]="dialog.fields"
  [form]="form" />
</div>
@if (form) {
  <div mat-dialog-actions
    class="action"
    >
    <button class="dialog-button"
      [class.submit]="canSubmit()"
      [disabled]="!canSubmit()"
      mat-raised-button
      color="accent"
    (click)="ok()">{{'BUTTONS.OK'| translate}}</button>
    @if (dialogRef.componentInstance.dialog.showCancelButton) {
      <button
        mat-raised-button
        mat-dialog-close
        (click)="cancel()"
      class="dialog-button">{{'BUTTONS.CANCEL'| translate}}</button>
    }
  </div>
}
